//certificate slider
$(".partner-slider").owlCarousel({
  dots: false,
  loop: true,
  autoplay: true,
  // slideSpeed: 2000,
  // scrollbarType: "scroll",
  // singleItem: true,
  margin: 24,
  responsiveClass: true,
  nav: false,
  autoHeight: true,
  slideTransition: 'linear',
  autoplayTimeout: 3000,
  smartSpeed: 3000,
  autoplaySpeed: 3000,
  autoplayHoverPause: true,
  center: false,
  responsive: {
      0: {
          items: 2,
      },
      575.98: {
          items: 2,
      },

      767.98: {
          items: 3,
      },

      991.98: {
          items: 3,
      },

      1199.98: {
          items: 4,
      },

      1399.98: {
          items: 4,
      }
  }

});

//Wow initialize reveal animation when scroll
wow = new WOW(
  {
  boxClass:     'wow',      // default
  animateClass: 'animate_fadeInUp', // default
  offset:       0,          // default
  mobile:       true,       // default
  live:         true        // default
}
)
wow.init();

//gallery slider
$(".gallery-slider").owlCarousel({
  dots: false,
  loop: false,
  autoplay: true,
  slideSpeed: 2000,
  scrollbarType: "scroll",
  //singleItem: true,
  margin: 30,
  responsiveClass: true,
  nav: false,
  autoHeight: true,
  rewind: true,
  navText: ["<i class=\"fa-solid fa-angle-left\"></i>", "<i class=\"fa-solid fa-angle-right\"></i>"],
  responsive: {
    0: {
      items: 1,
    },
    575.98: {
        items: 2,
    },

    767.98: {
        items: 2,
    },

    991.98: {
        items: 3,
    },

    1199.98: {
        items: 4,
    },

    1399.98: {
        items: 5,
    }
  }

});

//initialize fancybox gallery images
Fancybox.bind('[data-fancybox="portfolio_gallery"]', {
  //hideScrollbar: false,
});


// Form field show when select specific field
$("#ContactForm-Service_type").change(function() {
  if ($(this).val() == "Hourly / As Directed") {
    $('#hours_filed_show').show();
  }
  else{
    $('#hours_filed_show').hide();
  }
});
$("#ContactForm-Service_type").trigger("change");


// Function to open the popup and populate its content
$(".read-more").click(function() {
  var content = $(this).siblings(".box-para").html();
  $("#popup-para").html(content);
  $("#popup-container, #overlay").show();
  $("body").css("overflow", "hidden"); // Fix the body
});

$("#close-popup, #overlay").click(function() {
  $("#popup-container, #overlay").hide();
  $("body").css("overflow", "auto"); // Restore scrolling
});






